import React from 'react';

const BlogPagination = ({ currentPage, totalPages, onPageChange }) => {
  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    
    if (!showEllipsis) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);
      
      if (currentPage > 3) {
        pages.push('ellipsis-start');
      }
      
      // Show pages around current
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      
      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) {
          pages.push(i);
        }
      }
      
      if (currentPage < totalPages - 2) {
        pages.push('ellipsis-end');
      }
      
      // Always show last page
      if (!pages.includes(totalPages)) {
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const handlePageClick = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const pages = getPageNumbers();

  return (
    <nav className="blog_pagination" aria-label="Blog pagination">
      <ul className="pagination_list">
        {/* Previous Button */}
        <li className="pagination_item pagination_item--prev">
          <button
            className={`pagination_btn pagination_btn--nav ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => handlePageClick(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Go to previous page"
          >
            <i className="fa-solid fa-chevron-left"></i>
            <span className="btn_text">Previous</span>
          </button>
        </li>

        {/* Page Numbers */}
        {pages.map((page, index) => {
          if (typeof page === 'string') {
            return (
              <li key={page} className="pagination_item pagination_item--ellipsis">
                <span className="pagination_ellipsis">...</span>
              </li>
            );
          }
          
          return (
            <li key={page} className="pagination_item">
              <button
                className={`pagination_btn ${currentPage === page ? 'active' : ''}`}
                onClick={() => handlePageClick(page)}
                aria-label={`Go to page ${page}`}
                aria-current={currentPage === page ? 'page' : undefined}
              >
                {page}
              </button>
            </li>
          );
        })}

        {/* Next Button */}
        <li className="pagination_item pagination_item--next">
          <button
            className={`pagination_btn pagination_btn--nav ${currentPage === totalPages ? 'disabled' : ''}`}
            onClick={() => handlePageClick(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Go to next page"
          >
            <span className="btn_text">Next</span>
            <i className="fa-solid fa-chevron-right"></i>
          </button>
        </li>
      </ul>

      {/* Page Info */}
      <div className="pagination_info">
        Page <span className="current_page">{currentPage}</span> of <span className="total_pages">{totalPages}</span>
      </div>
    </nav>
  );
};

export default BlogPagination;